<div class="h-100 d-flex flex-column col-10 offset-xl-1">
  <div class="position-sticky bg-white">
    <h1 class="fw-bold font-34">Gestion des webinars</h1>
    <h6 class="lightGray2"><span class="mediumGray fw-bold">{{ webinarList.length }} webinars</span> en cours
      ou à venir</h6>

    <div class="w-100 d-flex flex-row gap1 filters">
      <mat-form-field appearance="fill">
        <mat-label>Organisé par</mat-label>
        <mat-select [formControl]="organisateurFormControl" multiple>
          <mat-option (click)="doFilter()" *ngFor="let value of orgaList" [value]="value">{{value}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Questions</mat-label>
        <mat-select [formControl]="hasQuestionFormControl">
          <mat-option (click)="doFilter()" [value]="null">Défault</mat-option>
          <mat-option (click)="doFilter()" [value]="true">Avec</mat-option>
          <mat-option (click)="doFilter()" [value]="false">Sans</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Statut</mat-label>
        <mat-select [formControl]="statusFormControl">
          <mat-option (click)="doFilter()" [value]="null">Défault</mat-option>
          <mat-option (click)="doFilter()" [value]="'upcoming'">A venir</mat-option>
          <mat-option (click)="doFilter()" [value]="'ended'">Passé</mat-option>
          <mat-option (click)="doFilter()" [value]="'online'">En cours</mat-option>
        </mat-select>
      </mat-form-field>


      <button class="btn btn-primary ms-auto d-flex flex-row align-items-center h-fit-content"
              (click)="goToLivestorm('homepage')">
        <mat-icon class="mr-2 text-white font-18 rounded-circle d-flex align-items-center justify-content-center">
          open_in_new
        </mat-icon>
        Accès Livestorm
      </button>
    </div>
  </div>


<!-- WEBINAR LIST -->
  <mat-accordion class="flex-grow-1 mt-2 info-accordion" *ngIf="webinarList && webinarList.length > 0">
    <mat-expansion-panel class="mb-3" *ngFor="let webinar of webinarList; let first = first" [hideToggle]="true"
                         [ngClass]="{'bg-grey': webinar.isOpened}"
                         (expandedChange)="webinar.isOpened = !webinar.isOpened">
      <!--   TITRE   -->
      <mat-expansion-panel-header>

        <mat-panel-title class="d-flex flex-column pt-2">
          {{ webinar.title ? webinar.title : 'titre manquant' }}

          <p class="mediumGray font-14" *ngIf="!webinar.isEdited"
             (click)="$event.stopPropagation();webinar.isEdited = true;editWebinar(webinar)">
            {{ webinar.title_fr ?  webinar.title_fr : 'Titre en français à remplir ici.' }}
          </p>

          <form class="d-flex align-items-center" *ngIf="webinar.isEdited" (click)="$event.stopPropagation()">

            <span class="material-icons-outlined font-14 pe-3 py-3" title="Annuler les modifications" *ngIf="webinar.isEdited && !webinar.isOpened"
                  (click)="$event.stopPropagation();webinar.isEdited = false; clearEditingField()">arrow_back_ios</span>

            <mat-form-field>
              <input type="text" matInput [formControl]="editFrTitle" placeholder="Titre en français ici">
              <mat-error>Ce champ doit être remplit.</mat-error>
            </mat-form-field>

            <span *ngIf="webinar.isEdited && !webinar.isOpened" class="material-icons-outlined font-16 p-3 text-success" title="Valider les modifications"
                  (click)="$event.stopPropagation();saveEvent(webinar)">done</span>

          </form>

        </mat-panel-title>

        <mat-panel-description class="d-flex align-items-center justify-content-end mr-0" style="gap: 100px">
          <div class="d-flex flex-column txt-darkGray">
            <strong>Dans x jour(s)</strong>
            <p class="mediumGray font-14">{{webinar.attribute && webinar.attribute.estimated_started_at ? ('le' + (webinar.attribute.estimated_started_at + '000' | date:'dd/MM/yyyy HH:mm')) : 'Date inconnue'}}</p>
          </div>
          <button
            class="btn text-uppercase rounded-pill bg-peach font-14 py-1 d-flex align-items-center gap-8 border-0">
            actions nécessaires
            <span class="material-icons-outlined bg-white rounded-circle font-18">add</span>
          </button>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <!--   INFORMATIONS   -->
      <div class="d-flex flex-row px-3 justify-content-between">
        <div class="d-flex flex-row justify-content-between gap-16 flex-grow-1" [ngClass]="['question-'+questionStatus, webinar.questions ? 'px-3 pb-3' : 'p-3']">

<!--     informations part     -->
          <div class="d-flex flex-column gap-16 event_box transition025 overflow-auto flex-grow-1 hidden-scrollbar">
            <div>
              <div class="d-flex justify-content-between">
                  <span class="fw-light">Resume (english) :</span>
                  <span class="material-icons pointer mediumGray transition05" *ngIf="webinar.questions" [ngClass]="questionStatus == 'small' ? 'transform270' : 'transform90'" (click)="switchQuestionBoxStatut('grow')">vertical_align_bottom</span>
                </div>
              <div class="br-4 p-1 mt-1" [innerHTML]="webinar.description ? webinar.description : 'No resume available.'"></div>
            </div>
            <div class="fw-lighter">
              Description (français) :
              <div class="p-1 mt-1 lightGray2 fw-normal" *ngIf="!webinar.isEdited" (click)="webinar.isEdited = true;editWebinar(webinar)">
                {{ webinar.description_fr ? webinar.description_fr : 'Description à remplir ici.' }}
              </div>

                <mat-form-field floatLabel="never" *ngIf="webinar.isEdited">
                  <textarea matInput [formControl]="editDescFC" rows="4"></textarea>
                  <mat-error>Ce champ doit être remplit.</mat-error>
                </mat-form-field>

              </div>

            <div *ngIf="webinar.isEdited && webinar.isOpened">
              <mat-form-field >
                <mat-label>Tag</mat-label>
                <mat-select [formControl]="editTagFC">
                  <mat-option *ngFor="let value of tagList" [value]="value">{{value}}</mat-option>
                </mat-select>
                <mat-error>Ce champ doit être remplit.</mat-error>
              </mat-form-field>

              <mat-form-field *ngIf="editTagFC.value && editTagFC.value == 'school'">
                <mat-label>Ecole</mat-label>
                <mat-select [formControl]="schoolTagFC">
                  <mat-option *ngFor="let value of schoolList" [value]="value.id">{{value.name}}</mat-option>
                </mat-select>
                <mat-error>Ce champ doit être remplit.</mat-error>
              </mat-form-field>
            </div>

            <div class="d-flex gap-8 align-items-center mt-3">
              <span class="material-icons-outlined font-14 pe-3 py-3 pointer" title="Annuler les modifications" *ngIf="webinar.isEdited"
                    (click)="$event.stopPropagation();webinar.isEdited = false; clearEditingField()">arrow_back_ios</span>
              <button class="btn btn-primary" *ngIf="webinar.isEdited && webinar.isOpened" (click)="saveEvent(webinar)">Sauvegarder les modifications</button>
            </div>

            </div>

<!--    question part      -->
            <div class="questions_box overflow-hidden transition025 flex-grow-1" *ngIf="webinar.questions">
              <div class="listing transition025 overflow-auto pe-2">
                <div class="d-flex justify-content-between">
                  <span class="mediumGray">Questions ({{ [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].length }}) :</span>
                  <span class="material-icons pointer mediumGray transform90"
                        (click)="switchQuestionBoxStatut('small')">vertical_align_bottom</span>
                </div>

                <div class="p-1 mt-1" *ngFor="let question of [0,1,2,3,4,5,6,7,8,9]; let index = index">
                  {{index}}.
                  Lorem ipsum dolor sit amet, consectetur adipisicing elit.
                  <div class="text-end font-10 lightGray2">Par <a href="#" class="lightGray2">username</a></div>
                </div>
              </div>
            </div>
        </div>

<!--    right part    -->
        <div class="d-flex flex-column gap-8 lf-after-bg yellow-after flex-shrink-0 pb-3">
          <div [style.background-image]="'url(' + (webinar.cover_image ? webinar.cover_image : defautCoverImage) + ')'"
               class="webinar_bg position-relative br-8 d-flex flex-wrap justify-content-between p-3 bgcover">

            <div class="w-50 text-white">Inscription ouvertes</div>

            <div class="w-50 text-end text-white">#{{webinar.id}}</div>

            <mat-chip-listbox aria-label="Webinar tags" class="webinar-tags pointer-ev-none w-50 align-self-end">
              <mat-chip-option class="font-12 text-nowrap">{{ webinar.tag ? (webinar.tag == 'school' ? webinar.school.slug : webinar.tag) : 'Choisir un tag' }}</mat-chip-option>
            </mat-chip-listbox>

        <!--           @TODO : à venir
         <span class="material-icons-outlined pointer txt-darkGray font-16 align-self-end"-->
        <!--                  title="Modifier la photo de couverture" (click)="openBgEdit(modal)">edit</span>-->

          </div>
          <div class="px-4">Inscriptions : <strong>xx personnes</strong></div>
          <div class="px-4">Places vacantes : <strong>xx</strong></div>
          <div class="px-4 mt-4">Organisateur :
            <strong>{{webinar.datas.owner ? webinar.datas.owner.attributes.first_name + ' ' + webinar.datas.owner.attributes.last_name : 'N/A'}}</strong>
          </div>
          <button
            class="btn semi-bold btn-primary-opacified d-flex flex-row align-items-center h-fit-content justify-content-center mt-2 py-2 mx-4 text-primary">
            <mat-icon class="mr-2 font-20 rounded-circle d-flex align-items-center justify-content-center">open_in_new
            </mat-icon>
            Voir sur Livestorm
          </button>
        </div>
      </div>
    </mat-expansion-panel>
  </mat-accordion>


</div>

<ng-template #modal let-modal>
  <app-file-upload></app-file-upload>
</ng-template>
